import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { toast } from "react-toastify";

// primereact
import { MultiSelect } from "primereact/multiselect";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
// components
import ModalEditCel from "./ModalEditCel";
import Modal from "../../../../../components/modal/Modal";

// context
import { useAiRegi } from "../../Context/AiRegiContext";

// services
import { getUsers } from "../../../../../services/GeneralRegistration/getUsers";
import { postWhitelistQuick } from "../../../../../services/QuickRegister/postWhitelistQuick";
import { getUser } from "../../../../../services/GeneralRegistration/getUser";
import { getWhitelistQuick } from "../../../../../services/QuickRegister/getWhitelistQuick";

const ModalWhiteList = ({ visible, onHide, loading, setLoading }) => {
  const { listData, setListData } = useAiRegi();
  const [showEditModal, setShowEditModal] = useState(false);
  const [editUserId, setEditUserId] = useState(null);
  const [editUserPhones, setEditUserPhones] = useState([]);

  const { data: users, isLoading } = useQuery({
    queryKey: ["getUsers"],
    queryFn: () => getUsers({ registration_type_id: 1 }),
    enabled: visible,
    refetchOnWindowFocus: false,
  });

  const {
    data: whitelist = [],
    isLoading: isWhitelistLoading,
    refetch,
  } = useQuery("getWhitelistQuick", getWhitelistQuick, {
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (visible) refetch();
  }, [visible, refetch]);

  const options = (users || [])
    .map((u) => {
      let telefones = [];
      if (Array.isArray(u.contacts) && u.contacts.length > 0) {
        telefones = u.contacts
          .filter((c) => c && typeof c.number === "string" && c.number.trim())
          .map((c) => ({
            id: c.id,
            number: c.number.trim(),
            type_number: c.type_number || 1,
          }));
      } else if (typeof u.contacts === "string" && u.contacts.length > 0) {
        telefones = u.contacts
          .split(",")
          .map((t, idx) => ({ id: idx, number: t.trim(), type_number: 1 }))
          .filter((t) => t.number.length > 0);
      }
      return {
        id: u.id,
        name: u.name,
        telefones,
      };
    })
    .filter((u) => Array.isArray(u.telefones) && u.telefones.length > 0);

  const optionLabel = (option) => {
    if (!option) return "";
    const tels =
      option.telefones && option.telefones.length > 0
        ? option.telefones.length > 2
          ? option.telefones.slice(0, 2).join(" / ") + " ..."
          : option.telefones.join(" / ")
        : "Sem telefone";
    return `${option.name}`;
  };

  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedPhones, setSelectedPhones] = useState([]);
  const [isDirty, setIsDirty] = useState(false);

  const { data: userData, isLoading: isLoadingContacts } = useQuery(
    ["getUserContacts", selectedUser?.id],
    () => getUser(selectedUser.id),
    {
      enabled: !!selectedUser?.id,
      refetchOnWindowFocus: false,
    }
  );

  const userContacts = Array.isArray(userData?.contacts)
    ? userData.contacts.filter(
        (t) =>
          t &&
          typeof t.number === "string" &&
          t.number.trim() !== "" &&
          t.type_number === 1
      )
    : [];

  const resetForm = () => {
    setSelectedUser(null);
    setSelectedPhones([]);
  };

  useEffect(() => {
    setIsDirty(false);
    if (selectedUser && Array.isArray(userContacts)) {
      const validPhones = userContacts;
      if (validPhones.length === 1) {
        if (
          selectedPhones.length !== 1 ||
          selectedPhones[0] !== validPhones[0].id
        ) {
          setSelectedPhones([validPhones[0].id]);
        }
      }
    } else {
      if (selectedPhones.length !== 0) {
        setSelectedPhones([]);
      }
    }
  }, [selectedUser, userContacts, visible]);

  const handleUserChange = (user) => {
    setSelectedUser(user);
    setIsDirty(true);
    setSelectedPhones([]);
  };

  const handlePhonesChange = (value) => {
    setSelectedPhones(value);
    setIsDirty(true);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!selectedUser || selectedPhones.length === 0) return;
    const toastId = toast.loading("Adicionando...");
    setLoading(true);
    try {
      await postWhitelistQuick({
        user_id: selectedUser.id,
        contacts: selectedPhones,
      });
      toast.update(toastId, {
        render: "Adicionado com sucesso!",
        type: "success",
        isLoading: false,
        autoClose: 2000,
      });
      if (typeof refetch === "function") refetch();
      resetForm();
      onHide();
    } catch (e) {
      toast.update(toastId, {
        render: "Erro ao adicionar",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
      console.error("Erro ao adicionar:", e);
    } finally {
      setLoading(false);
    }
  };

  const handleEditTelefone = (novosTelefones) => {
    if (showEditModal && editUserId) {
      setListData((prev) =>
        prev.map((item) => {
          if (item.id === editUserId) {
            return {
              ...item,
              pessoa: {
                ...item.pessoa,
                contacts: novosTelefones.map((tel) => ({ number: tel })),
              },
            };
          }
          return item;
        })
      );
    }
  };

  const userAlreadyInList =
    selectedUser &&
    whitelist.some(
      (u) =>
        u.id === selectedUser.id ||
        (u.pessoa && u.pessoa.id === selectedUser.id)
    );
  const pessoaNaLista = userAlreadyInList
    ? whitelist.find(
        (u) =>
          u.id === selectedUser.id ||
          (u.pessoa && u.pessoa.id === selectedUser.id)
      )
    : null;

  return (
    <>
      <Modal
        dynamicTitle="Adicionar pessoa a lista"
        visible={visible}
        style={{
          width: "400px",
          zIndex: 10000,
        }}
        onHide={onHide}
        modal={true}
      >
        <form
          onSubmit={onSubmit}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
            padding: 0,
            margin: 0,
          }}
        >
          <div
            style={{
              width: "100%",
              marginBottom: 16,
              height: 48,
              display: "flex",
              alignItems: "center",
            }}
          >
            <Dropdown
              filter
              showClear
              inputId="pessoa-dropdown"
              value={selectedUser}
              onChange={(e) => handleUserChange(e.value)}
              options={options}
              optionLabel={optionLabel}
              placeholder={isLoading ? "Carregando..." : "Selecione uma pessoa"}
              style={{ height: 48, width: "100%", zIndex: 11000 }}
              disabled={loading || isLoading}
              onKeyDown={(e) => {
                if (e.key === "Enter") e.preventDefault();
              }}
            />
          </div>
          {userAlreadyInList && (
            <div
              style={{
                width: "100%",
                marginBottom: 12,
                color: "#f59e42",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <span>Usuário já está na lista.</span>
            </div>
          )}

          {!userAlreadyInList && selectedUser && userContacts.length > 0 && (
            <div style={{ width: "100%", marginBottom: 16 }}>
              {isLoadingContacts ? (
                <div
                  style={{
                    width: "100%",
                    textAlign: "center",
                    padding: "12px 0",
                  }}
                >
                  Carregando...
                </div>
              ) : (
                <MultiSelect
                  value={selectedPhones}
                  onChange={(e) => handlePhonesChange(e.value)}
                  options={userContacts.map((tel) => ({
                    label: tel.number,
                    value: tel.id,
                  }))}
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Selecione os telefones"
                  style={{ width: "100%" }}
                  disabled={userContacts.length === 0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") e.preventDefault();
                  }}
                />
              )}
            </div>
          )}
          <div
            className="d-flex justify-content-end mt-5"
            style={{ width: "100%" }}
          >
            <Button
              type="submit"
              label="Adicionar"
              icon="pi pi-check"
              disabled={
                userAlreadyInList ||
                !selectedUser ||
                selectedPhones.length === 0 ||
                loading ||
                isLoading
              }
              style={{ minWidth: 120, zIndex: 1 }}
              className="p-button-rounded"
              loading={loading}
            />
          </div>
        </form>
      </Modal>
      <ModalEditCel
        visible={showEditModal}
        onHide={() => setShowEditModal(false)}
        userId={editUserId}
        telefones={editUserPhones}
        onConfirm={handleEditTelefone}
        usuario={pessoaNaLista}
      />
    </>
  );
};

export default ModalWhiteList;
